module.exports = __webpack_public_path__ + "media/images/icons/008__choose-3cd2d1fdb437fcb8906a660d1d7b9ce1.svg";